import { render, staticRenderFns } from "./BookingAdminForm.vue?vue&type=template&id=d0e25c58&"
import script from "./BookingAdminForm.vue?vue&type=script&lang=js&"
export * from "./BookingAdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports